import {
    Component,
    Input,
    OnInit,
    EventEmitter,
    Inject,
    forwardRef
} from '@angular/core';

import {Location} from '@angular/common';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/primeng';
import {HomeComponent} from '../home.component';
import {AuthService} from '../../core/security/auth.service';
import {Observable} from 'rxjs/Observable';
import {View, views} from 'app/core/domain/view';
import {MenuEntry, menuEntries} from 'app/core/domain/menu-entry';
import {isNumber} from 'util';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'home-menu',
    template: `
                <ul app-submenu [item]="model" root="true"
                class="ultima-menu ultima-main-menu clearfix" [reset]="reset" visible="true"></ul>
            `
})
//TODO: Refactorizar el menu!
export class MenuComponent implements OnInit {

    @Input() reset: boolean;

    model: any[];

    menuEntryMap: {[id: number]: MenuEntry} = {};

    viewMap: {[id: number]: View} = {};

    constructor(@Inject(forwardRef(() => HomeComponent)) public app: HomeComponent,
                private authService: AuthService) {
        menuEntries.forEach(menuEntry => this.menuEntryMap[menuEntry.id] = menuEntry);
        views.forEach(view => this.viewMap[view.id] = view)
    }

    ngOnInit() {
        this.buildMenu().subscribe(menu => this.model = menu);
    }

    private buildMenu(): Observable<any[]> {

        return this.authService.user
            .map(user => {
                const menu: any[] = [];
                views
                    .filter(view => view.menuEntryId != null && view.hasAccess(user))
                    .map(view => this.stackMenu(view))
                    .forEach(stack => this.parseMenuStack(stack, menu));
                return menu;
            });
    }

    private parseMenuStack(stack: any[], menu: any[], level: number = 0) {
        if (level >= stack.length) return;
        if (isNumber(stack[level])) {
            const menuEntryId: number = stack[level];
            let mi = menu.find(me => me.id == menuEntryId);
            if (mi) this.parseMenuStack(stack, mi.items, level + 1);
            else {
                const menuEntry: MenuEntry = this.menuEntryMap[menuEntryId];
                mi = {id: menuEntryId, label: menuEntry.label, icon: menuEntry.icon, items: []};
                menu.push(mi);
                this.parseMenuStack(stack, mi.items, level + 1);
            }
        }else {
            menu.push(stack[level]);
            return;
        }
    }


    private stackMenu(view: View) {
        let me: MenuEntry = this.menuEntryMap[view.menuEntryId];
        const result: any[] = [{id: me.id, label: me.label, icon: me.icon, routerLink: view.route}];
        while (me.parentId != null) {
            me = this.menuEntryMap[me.parentId];
            result.unshift(me.id);
        }
        return result;
    }


    changeTheme(theme) {
        const themeLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById('theme-css');
        const layoutLink: HTMLLinkElement = <HTMLLinkElement> document.getElementById('layout-css');

        themeLink.href = 'assets/theme/theme-' + theme + '.css';
        layoutLink.href = 'assets/layout/css/layout-' + theme + '.css';
    }
}

@Component({
    selector: '[app-submenu]',
    template: `
        <ng-template ngFor let-child let-i="index" [ngForOf]="(root ? item : item.items)">
            <li [ngClass]="{'active-menuitem': isActive(i)}" *ngIf="child.visible === false ? false : true">
                <a [href]="child.url||'#'" (click)="itemClick($event,child,i)" class="ripplelink"
                *ngIf="!child.routerLink" [attr.tabindex]="!visible ? '-1' : null">
                    <i class="material-icons">{{child.icon}}</i>
                    <span>{{child.label}}</span>
                    <i class="material-icons" *ngIf="child.items">keyboard_arrow_down</i>
                </a>

                <a (click)="itemClick($event,child,i)" class="ripplelink" *ngIf="child.routerLink"
                    [routerLink]="child.routerLink" routerLinkActive="active-menuitem-routerlink" [routerLinkActiveOptions]="{exact: true}" [attr.tabindex]="!visible ? '-1' : null">
                    <i class="material-icons">{{child.icon}}</i>
                    <span>{{child.label}}</span>
                    <i class="material-icons" *ngIf="child.items">keyboard_arrow_down</i>
                </a>
                <ul app-submenu [item]="child" *ngIf="child.items"
                    [@children]="isActive(i) ? 'visible' : 'hidden'" [visible]="isActive(i)" [reset]="reset">
                </ul>
            </li>
        </ng-template>
    `,
    animations: [
        trigger('children', [
            state('hidden', style({
                height: '0px'
            })),
            state('visible', style({
                height: '*'
            })),
            transition('visible => hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hidden => visible', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ]
})
export class AppSubMenu {

    @Input() item: MenuItem;

    @Input() root: boolean;

    @Input() visible: boolean;

    _reset: boolean;

    activeIndex: number;

    constructor(@Inject(forwardRef(() => HomeComponent)) public app: HomeComponent, public router: Router, public location: Location) {
    }

    itemClick(event: Event, item: MenuItem, index: number) {
        //avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        //activate current item and deactivate active sibling if any
        this.activeIndex = (this.activeIndex === index) ? null : index;

        //execute command
        if (item.command) {
            if (!item['eventEmitter']) {
                item['eventEmitter'] = new EventEmitter();
                item['eventEmitter'].subscribe(item.command);
            }

            item['eventEmitter'].emit({
                originalEvent: event,
                item: item
            });
        }

        //prevent hash change
        if (item.items || (!item.url && !item.routerLink)) {
            event.preventDefault();
        }

        //hide menu
        if (!item.items) {
            if (this.app.isHorizontal())
                this.app.resetMenu = true;
            else
                this.app.resetMenu = false;

            this.app.overlayMenuActive = false;
            this.app.staticMenuMobileActive = false;
        }

    }

    isActive(index: number): boolean {
        return this.activeIndex === index;
    }

    @Input() get reset(): boolean {
        return this._reset;
    }

    set reset(val: boolean) {
        this._reset = val;

        if (this._reset /*&& this.app.isHorizontal()*/) {
            this.activeIndex = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/home/menu/menu.component.ts